module.exports = __webpack_public_path__ + "static/img/parner.673a6d23.png";